export default "data:application/octet-stream;base64,QGltcG9ydCAidG9rZW5zLWRlZmF1bHQiOw0KQGltcG9ydCAicmVzcG9uc2l2ZSI7DQpAaW1wb3J0ICJlZmZlY3QiOw0K"